import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';

const TeamDateCards = (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data
    return (
        <div className={isMobile? '' : "flex"}>
            {
                isMobile &&
                <div className='card'>
                    <h5>Team</h5>
                    <p>{check.teamName}</p>
                </div>
            }
            <div className={isMobile? 'flex-max' : "flex-max"}>
                {
                    !isMobile &&
                    <div className='card'>
                        <h5>Team</h5>
                        <p>{check.teamName}</p>
                    </div>
                }
                <div className='card'>
                    <h5>Date</h5>
                    <p>{check.date}</p>
                </div>
                <div className='card'>
                    <h5>User</h5>
                    <p>{check.userName}</p>
                </div>
            </div>

        </div>
    )
}

export default TeamDateCards